define('drops/sketchPad/sketchPad',[
    'jquery',
    'lq/drop',
    'lq/style',
    'drops/sketchPad/canvasMorph',
    'lq/util',
    'lq/dynamicContentImage',
    'lq/required'
], function ($, Drop, style, CanvasMorph, util, dynamicContentImage, Required) {
    'use strict';

    var defaults = {
        data: {
            selectedResizeOption: 'Stretch Image',
            defaultMarkerColor: 'rgba(51, 51, 51, 0.6)',
            defaultPenColor: 'rgba(51, 51, 51, 1)',
            showUndoRedo: true,
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            disableZooming: false,
            enablePinchMove: false,
            disableMovingBg: false,
            exportType: 'sketchpad',
            exportCrop: false
        }
    };

    function SketchPad(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        var self = this;

        self.$toolbar = $('<table />');
        self.$toolbar.css({
            width: 'auto'
        });

        self.$canvas = $('<canvas />');
        self.$canvas.addClass('boxToBorderSize');
        self.$canvas.css({
            width: (self.data.size.x) + 'px',
            height: (self.data.size.y - 90) + 'px',
            zIndex: self.data.zIndex,
            position: 'relative'
        });
        self.$stylePickerContainer = $('<div id="stylePickerContainer" />').css({
            position: 'absolute',
            top: '77px',
            left: '3px',
            zIndex: self.data.zIndex + 1
        });

        style.renderStyles(self, null, self.$canvas);
        self.$toolbar.appendTo(self.$element);
        self.$stylePickerContainer.appendTo(self.$element);
        self.$canvas.appendTo(self.$element);
    };

    Drop.extend(SketchPad, Drop);

    SketchPad.typeName = 'SketchPad';

    SketchPad.prototype.onResizeOptions = [
        { key: 'Stretch Image', value: 'Stretch Image' },
        { key: 'No-Resize', value: 'No-Resize' },
        { key: 'Keep Ratio, Show Complete Image', value: 'Keep Ratio, Show Complete Image' },
        { key: 'fillKeepRatio', value: 'Fill, keep ratio' }
    ];

    SketchPad.prototype.renderStyles = function () {
        style.renderStyles(this, null, this.$canvas);
        this.$canvas.css('padding-top', '55px');
    };

    SketchPad.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
    };

    SketchPad.prototype.postRender = function () {
        var self = this;
        //setTimeout solves render exception in chrome
        setTimeout(function () {
            var selectedResizeOption = self.data.selectedResizeOption;
            var isClearEventEnabled = self.isEventEnabled('clearClicked');
            var triggerClearEventFunction = function () {
                self.triggerEventIfEnabled('clearClicked');
            };
            var isOnReleaseEnabled = self.isEventEnabled('onRelease');
            var triggerOnReleaseEventFunction = function () {
                self.triggerEventIfEnabled('onRelease');
            };
            var isOnUndoEventEnabled = self.isEventEnabled('onUndo');
            var triggerOnUndoEventFunction = function () {
                self.triggerEventIfEnabled('onUndo');
            };
            var isOnRedoEventEnabled = self.isEventEnabled('onRedo');
            var triggerOnRedoEventFunction = function () {
                self.triggerEventIfEnabled('onRedo');
            };

            self.canvasMorph = new CanvasMorph(
                self.data,
                self.$canvas,
                self.$toolbar,
                self.$stylePickerContainer,
                self.piping.parameters,
                {
                    selectedResizeOption: selectedResizeOption,
                    isClearEventEnabled: isClearEventEnabled,
                    triggerClearEventFunction: triggerClearEventFunction,
                    isOnReleaseEnabled: isOnReleaseEnabled,
                    triggerOnReleaseEventFunction: triggerOnReleaseEventFunction,
                    isOnUndoEventEnabled: isOnUndoEventEnabled,
                    triggerOnUndoEventFunction: triggerOnUndoEventFunction,
                    isOnRedoEventEnabled: isOnRedoEventEnabled,
                    triggerOnRedoEventFunction: triggerOnRedoEventFunction
                },
                self.piping.$actionWrapper
                );

            self.canvasMorph.buildCanvas();

            setTimeout(function () { // We have to wait till the toolbar gets fully rendered
                self.adjustCanvasSize();
            }, 101);
        }, 0);
    };

    SketchPad.prototype.clearValue = function () {
        var self = this;
        // because the creating of canvasMorph is in a setTimeout as well
        setTimeout(function () {
            self.canvasMorph.setValue();
            self.canvasMorph.updateRequiredIndicator();
        }, 0);
    };

    SketchPad.prototype.setValue = function (update) {
        var self = this;
        // because the creating of canvasMorph is in a setTimeout as well
        setTimeout(function () {
            self.canvasMorph.setValue(update.value);
            self.canvasMorph.updateRequiredIndicator();
        }, 0);
    };

    SketchPad.prototype.getValue = function () {
        var svg = this.canvasMorph.createSvg();
        return 'data:image/svg+xml;base64,' + btoa(svg);
    };

    SketchPad.prototype.getFile = function () {
        return this.data.exportType === 'sketchpad'
            ? this.getValue()
            : this.canvasMorph.createImage(this.data.exportCrop, 'image/png');e;
    };

    SketchPad.prototype.hasValue = function () {
        if (this.canvasMorph.clicks.length !== 0)
            return true;
        else
            return false;
    };

    SketchPad.prototype.clearBackground = function () {
        // redraw(img, isNewBgImg, isClearBg)
        this.canvasMorph.redraw(null, true, true);
        this.canvasMorph.hasBgImage = false;
    };

    SketchPad.prototype.updateImage = function(src, alt) {
        // redraw(img, isNewBgImg, isClearBg)
        this.canvasMorph.redraw(src, true);
        this.canvasMorph.hasBgImage = true;
    };

    SketchPad.prototype.getPathFromSrcString = function (src) {
        return dynamicContentImage.getPath({
            imageName: src,
            useThumbnail: false,
            resizeOption: this.data.selectedResizeOption,
            size: this.data.size
        });
    };

    SketchPad.prototype.licquidMethod_setBackgroundImage = function (args) {
        var value = util.convertListOfKeyValuesToObject(args.document);

        if (!value) {
            this.clearBackground();
        } else if ($.type(value) === 'string') {
            var srcPath = this.getPathFromSrcString(value);
            this.updateImage(srcPath, '');
        } else {
            var url = args.document.url || args.document.Url;

            if (url) {
                var documentPath = this.getPathFromSrcString(url);

                if (documentPath)
                    this.updateImage(documentPath, args.document.filename || args.document.Filename);
                else
                    this.clearBackground();
            }
        }
    };

    SketchPad.prototype.licquidMethod_clearDrawing = function () {
        this.canvasMorph.clearDrawing();
        this.canvasMorph.setValue();
        this.canvasMorph.redraw();
    };

    SketchPad.prototype.postWindowResize = function () {
        if (this.canvasMorph && this.designData) {
            this.adjustCanvasSize();
        }
    };

    SketchPad.prototype.adjustCanvasSize = function () {
        var borderLeft = parseFloat(this.$canvas.css('border-left-width'));
        var borderTop = parseFloat(this.$canvas.css('border-top-width'));
        var borderRight = parseFloat(this.$canvas.css('border-right-width'));
        var borderBottom = parseFloat(this.$canvas.css('border-bottom-width'));

        var dropWidth = this.$element.width() - (borderLeft ? borderLeft : 0) - (borderRight ? borderRight : 0);
        var dropHeight = this.$element.height() - (borderTop ? borderTop : 0) - (borderBottom ? borderBottom : 0);

        var toolbarHeight = this.$toolbar.height();

        if (dropWidth < 1 || dropHeight - toolbarHeight < 1) {
            this.$toolbar.width(54);
            this.canvasMorph.resizerRedraw(1, 1);
        } else {
            this.$toolbar.width(dropWidth);
            this.canvasMorph.resizerRedraw(dropWidth, dropHeight - toolbarHeight);
        }
    };

    return SketchPad;
});
